export default __webpack_public_path__ + "static/media/in_progress_mobile.a2b17290.svg";